export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";